import React from 'react';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { ExtendedProvider, Log } from 'Src/types';
import { CtaListItemBase, ListItemButtonProps } from './CtaListItemBase';
import { DefaultCtaListItem, trackListItemClick, messages } from '../../lib';

interface BaseVirtualCareListItemProps {
  provider: ExtendedProvider;
  log: Log;
}
type VirtualCareListItemProps = BaseVirtualCareListItemProps &
  WrappedComponentProps;

export const VirtualCareListItem = injectIntl(
  ({ provider, intl, log }: VirtualCareListItemProps) => {
    const primaryText = intl.formatMessage(messages.virtualCareTitle);
    const secondaryText =
      intl.formatMessage(messages.virtualCareSubtitle) === ' '
        ? undefined
        : intl.formatMessage(messages.virtualCareSubtitle);
    const href = provider.virtual_care_url ?? undefined;
    const handleClick = () => {
      trackListItemClick({
        log,
        listItem: DefaultCtaListItem.VirtualCare,
        providerId: provider.id,
        primaryText,
        secondaryText
      });
    };

    const buttonProps: ListItemButtonProps = {
      component: 'a',
      href,
      role: 'link',
      target: '_blank',
      rel: 'noopener noreferrer',
      onClick: handleClick
    };
    return (
      <CtaListItemBase
        buttonProps={buttonProps}
        primaryText={primaryText}
        secondaryText={secondaryText}
        isExternalLink={true}
      />
    );
  }
);
